import Image from 'react-bootstrap/Image';

import portugues from '../images/portugues.png'
import ingles from '../images/ingles.png'
import espanhol from '../images/espanhol.png'
import frances from '../images/frances.png'

function Idiomas({ idioma, setIdioma, condicaoExibirIngles, condicaoExibirEspanhol, condicaoExibirFrances, resolucaoMobile }) {
    function idiomaIngles() {
        setIdioma('en')
    }

    function idiomaPortugues() {
        setIdioma('pt')
    }

    function idiomaEspanhol() {
        setIdioma('es')
    }

    function idiomaFrances() {
        setIdioma('fr')
    }

    return (
        <div style={{ background: 'white', padding: '5px', borderRadius: '10px' }} className='mt-3 d-flex align-items-center justify-content-space-evenly nav'>
            <Image onClick={idiomaPortugues} style={{ cursor: 'pointer', width: '25px', filter: idioma === 'pt' || !idioma ? 'grayscale(0)' : 'grayscale(1)' }} className='mx-2' src={portugues} alt="logo" fluid />
            {condicaoExibirIngles ? <Image onClick={idiomaIngles} style={{ cursor: 'pointer', width: '25px', filter: idioma === 'en' ? 'grayscale(0)' : 'grayscale(1)' }} className='mx-2' src={ingles} alt="logo" fluid /> : <></>}
            {condicaoExibirEspanhol ? <Image onClick={idiomaEspanhol} style={{ cursor: 'pointer', width: '25px', filter: idioma === 'es' ? 'grayscale(0)' : 'grayscale(1)' }} className='mx-2' src={espanhol} alt="logo" fluid /> : <></>}
            {condicaoExibirFrances ? <Image onClick={idiomaFrances} style={{ cursor: 'pointer', width: '25px', filter: idioma === 'fr' ? 'grayscale(0)' : 'grayscale(1)' }} className='mx-2' src={frances} alt="logo" fluid /> : <></>}
        </div>
    );
}
export default Idiomas;
